module.exports = __webpack_public_path__ + "img/liushui (10).eefb12bd.png";